import SectionHeading from "../../components/Typography/SectionHeading";
import { projects } from "./projects";
import "../../components/PortfolioCard/index.css";

function ExternalLinkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
}

function Work() {
  return (
    <section id="work" className="container pt-16 tablet:py-0">
      <SectionHeading
        text="Work"
        subtitle="Selected organisations and products I've contributed to, spanning SaaS, enterprise platforms, and customer-facing applications."
      />

      <div className="portfolio-page__grid">
        {projects.map((project) => (
          <article key={project.title} className="portfolio-card group">
            <div className="portfolio-card__image">
              <img
                src={project.image}
                alt={`${project.title} project preview`}
                loading="lazy"
              />
            </div>

            <div className="portfolio-card__body">
              <span className="portfolio-card__category">{project.category}</span>
              <h3 className="portfolio-card__title">{project.title}</h3>
              <p className="portfolio-card__description">{project.description}</p>
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="portfolio-card__link"
                aria-label={`Visit ${project.title} website`}
              >
                Visit site
                <ExternalLinkIcon />
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Work;
